import { useEffect } from "react";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";

const CouponRow = ({ couponId, couponIduserInfo, couponDate }) => {
  const gestioneCouponsTranslation = useSelector(
    (state) => state.translations.coupons
  );

  useEffect(() => {}, []);

  return (
    <div className="grid grid-cols-60 sm:gap-2 2xl:gap-4 text-ribola-tundora border-b border-ribola-dove-gray border-opacity-20 py-4">
      <div className="col-span-22 sm:col-span-12 md:col-span-10 flex items-center">
        {couponDate}
      </div>
      <div className="col-span-16 sm:col-span-12 md:col-span-10 flex items-center">
        {couponIduserInfo}
      </div>
    </div>
  );
};

export default CouponRow;
